module.exports = __webpack_public_path__ + "avai.793330f48443f052b205.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/avai.woff
// module id = ./src/assets/webfonts/avai.woff
// module chunks = styles